type ButtonCapsuleProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    children: React.ReactNode;
};

// A real <button> (it was a clickable <div>, unreachable by keyboard), set as
// the On Air primary plate (`.btn-signal`, styles/globals.scss).
const ButtonCapsule = ({ children, className = "", ...props }: ButtonCapsuleProps) => {
    return (
    <button type="button" className={`btn-signal ${className}`} {...props}>
        {children}
    </button>
    )
}

export default ButtonCapsule
